import { render, staticRenderFns } from "./MtCasesForm.vue?vue&type=template&id=3b6e2727&"
import script from "./MtCasesForm.vue?vue&type=script&lang=js&"
export * from "./MtCasesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports